import { memo } from 'react';
import Slider from '@dtvgo/slider';
import { ProgressBarClassNames } from './utils.js';
import { jsx } from 'react/jsx-runtime';
import '@dtvgo/classnames';

/* External */
function ProgressDot(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className;
  return /*#__PURE__*/jsx(Slider.Dot, {
    className: ProgressBarClassNames.element('progress-dot', className)
  });
}
var ProgressDot$1 = /*#__PURE__*/memo(ProgressDot);

export { ProgressDot$1 as default };
//# sourceMappingURL=ProgressDot.js.map
